export enum IGNORE_EVENT_TYPES {
  LIGHT = 'light',
  SEAL_OPEN = 'seal_open',
  DOOR_OPEN = 'door_open',
  LIGHT_STOP_COMPOUND = 'light_and_stop_compound',
}